/**
 * Normalize API image URLs to same-origin /storage paths when possible.
 * @param {string | null | undefined} url
 */
export function normalizeServiceImageUrl(url) {
  if (!url || typeof url !== 'string') {
    return null
  }

  const trimmed = url.trim()
  if (trimmed === '') {
    return null
  }

  if (trimmed.startsWith('/storage/')) {
    return trimmed
  }

  try {
    const parsed = new URL(trimmed, window.location.origin)
    if (parsed.pathname.startsWith('/storage/')) {
      return `${parsed.pathname}${parsed.search}`
    }
  } catch {
    return trimmed
  }

  return trimmed
}

/**
 * @param {import('@/types/api').Service | { image_url?: string | null; category?: { colour?: string | null } | null }} service
 */
export function resolveServiceImageUrl(service) {
  return normalizeServiceImageUrl(service?.image_url)
}

/**
 * @param {import('@/types/api').Service | { category?: { colour?: string | null } | null }} service
 * @param {string} [fallbackColour]
 */
export function serviceImageFallbackStyle(service, fallbackColour = '#7C3AED') {
  const colour = service?.category?.colour ?? fallbackColour

  return {
    '--pos-card-accent': colour,
    background: `linear-gradient(145deg, ${colour}18 0%, ${colour}38 55%, ${colour}22 100%)`,
  }
}
